<template>
  <v-card>
    <v-list>
      <v-list-tile avatar>
        <v-list-tile-avatar>
          <v-icon large>edit</v-icon>
        </v-list-tile-avatar>

        <v-list-tile-content>
          <v-list-tile-title>Edit Visa Number</v-list-tile-title>
        </v-list-tile-content>

        <v-list-tile-action>
          <v-btn icon fav small outline @click="onCancelled">
            <v-icon>clear</v-icon>
          </v-btn>
        </v-list-tile-action>
      </v-list-tile>
    </v-list>
    <v-divider></v-divider>
    <v-card-text style="max-height: 85%">
      <v-form ref="editVisaNumberForm" v-model="valid" lazy-validation>
        <v-layout column>
          <v-flex xs12 pb-4>
            <v-autocomplete
              label="Company *"
              v-model="editItem.employer_id"
              :items="employersTV"
              hide-details
              hide-selected
              item-text="text"
              item-value="value"
              outline
              required
              :rules="requiredRules"
            >
            </v-autocomplete>
          </v-flex>
          <v-flex xs12>
            <v-text-field
              outline
              label="Visa Number *"
              v-model="editItem.visa_no"
              required
              :rules="requiredRules"
            ></v-text-field>
          </v-flex>
          <v-flex xs12>
            <v-text-field
              outline
              label="Visa Quantity *"
              v-model="editItem.qty"
              required
              :rules="requiredRules"
            ></v-text-field>
          </v-flex>
        </v-layout>
      </v-form>
    </v-card-text>
    <v-divider></v-divider>
    <v-card-actions>
      <v-spacer></v-spacer>
      <v-btn @click="onCancelled">Cancel</v-btn>
      <v-btn
        color="blue"
        @click="editItemDo"
        :disabled="!valid || actionButtonClicked"
        :loading="actionButtonClicked"
        >Update</v-btn
      >
    </v-card-actions>
  </v-card>
</template>

<script>
import { GENDERS } from "../../mdsir/const";

export default {
  props: ["editItem", "employersTV"],
  data() {
    return {
      actionButtonClicked: false,
      valid: true,
    };
  },
  methods: {
    onCancelled() {
      this.$emit("cancelled");
    },
    validate() {
      if (this.$refs.editVisaNumberForm.validate()) {
        this.snackbar = true;
      }
    },
    reset() {
      this.$refs.editVisaNumberForm.reset();
    },
    resetValidation() {
      this.$refs.editVisaNumberForm.resetValidation();
    },
    // clearForm() {
    //   this.editItem.full_name = "";
    //   this.editItem.age = "";
    //   this.editItem.phone = "";
    //   this.editItem.notes = "";
    // },
    editItemDo() {
      if (this.$refs.editVisaNumberForm.validate()) {
        this.actionButtonClicked = true;
        this.put("/visa_number", this.editItem).then((res) => {
          if (res.data.success) {
            this.onCancelled();
          }
          this.snackbarShow(res.data);
          this.actionButtonClicked = false;
        });
      }
    },
  },
  mounted() {},
  created() {
    this.GENDERS = GENDERS;
  },
};
</script>
